module.exports = __webpack_public_path__ + "img/favicon-196.a0d33ee5.png";